export default __webpack_public_path__ + "static/media/partnershipIcon4.3d014959.png";